<template>
  <div class="new-login-container">
    <bert-loading 
      v-if="isLoading" 
      :fullscreen="true" 
      size="lg" 
      text="Loading"
    />

    <!-- Main Content -->
    <div v-else class="login-wrapper">
      <div class="back-button-fixed">
        <button @click="goBack" class="back-button-circle">
          <i class="mdi mdi-arrow-left"></i>
        </button>
      </div>
      <!-- Desktop Layout -->
      <div class="desktop-layout">
        <!-- Left Side - Banner -->
        <div class="banner-section">
          <div class="banner-content">
            <img src="@/assets/banner-auth.svg" alt="Community Banner" class="banner-image" />
            <div class="member-badge">
              <img src="@/assets/sub-banner-auth.svg" alt="5000+ Members" class="member-image" />
            </div>
          </div>
        </div>

        <!-- Right Side - Login Form -->
        <div class="form-section">
          <div class="form-card">
            <div class="form-container">
              <!-- Logo -->
              <div class="logo-container">
                <img src="@/assets/berts-logo-header.png" alt="Bert Points Logo" class="logo" />
              </div>

              <!-- Form Title -->
              <h2 class="form-title">Welcome Back!</h2>

              <!-- Login Form -->
              <form @submit.prevent="submitData" class="login-form">
                <div class="form-group">
                  <label for="username">Email :</label>
                  <div class="input-wrapper">
                    <i class="input-icon mdi mdi-email"></i>
                    <input
                      type="username"
                      id="username"
                      v-model="forms.username"
                      placeholder="Masukkan Email Terdaftar"
                      required
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="password">Kata Sandi :</label>
                  <div class="input-wrapper">
                    <i class="input-icon mdi mdi-lock"></i>
                    <input
                      type="password"
                      id="password"
                      v-model="forms.password"
                      placeholder="Masukkan Kata Sandi"
                      required
                    />
                    <i class="password-toggle mdi mdi-eye" @click="togglePassword('password')"></i>
                  </div>
                </div>

                <!-- Form Actions -->
                <div class="form-actions">
                  <bert-button 
                    type="submit" 
                    variant="primary" 
                    size="lg"
                    :full-width="true"
                    :loading="isLoading"
                    :disabled="isLoading"
                  >
                    Masuk
                  </bert-button>
                </div>

                <!-- Forgot Password Link -->
                <div class="forgot-password">
                  <router-link to="/forgot-password" class="link-primary">Lupa Password?</router-link>
                </div>

                <!-- Register Link -->
                <div class="register-link">
                  Belum Punya Akun? <router-link to="/registrasi" class="link-primary">Daftar Disini</router-link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="mobile-layout">
        <div class="mobile-container">
          <!-- Logo -->
          <div class="mobile-logo">
            <img src="@/assets/berts-logo-header.png" alt="Bert Points Logo" class="logo" />
          </div>

          <!-- Form Title -->
          <h2 class="mobile-title">Welcome Back!</h2>

          <!-- Login Form -->
          <form @submit.prevent="submitData" class="mobile-form">
            <div class="mobile-form-group">
              <label for="mobile-username">Email :</label>
              <div class="mobile-input-wrapper">
                <i class="input-icon mdi mdi-email"></i>
                <input
                  type="email"
                  id="mobile-username"
                  v-model="forms.username"
                  placeholder="Masukkan Email Aktif"
                  required
                />
              </div>
            </div>

            <div class="mobile-form-group">
              <label for="mobile-password">Kata Sandi :</label>
              <div class="mobile-input-wrapper">
                <i class="input-icon mdi mdi-lock"></i>
                <input
                  type="password"
                  id="mobile-password"
                  v-model="forms.password"
                  placeholder="Masukkan Kata Sandi"
                  required
                />
                <i class="password-toggle mdi mdi-eye" @click="togglePassword('mobile-password')"></i>
              </div>
            </div>

            <!-- Forgot Password Link -->
            <div class="mobile-forgot-password">
              <router-link to="/forgot-password" class="link-primary">Lupa Kata Sandi?</router-link>
            </div>

            <!-- Register Link -->
            <div class="mobile-register-link">
              Belum Punya Akun? <router-link to="/registrasi" class="link-primary">Daftar Disini</router-link>
            </div>

            <!-- Form Actions -->
            <div class="mobile-form-actions">
              <bert-button 
                type="submit" 
                variant="primary" 
                size="lg"
                :full-width="true"
                :loading="isLoading"
                :disabled="isLoading"
              >
                Masuk
              </bert-button>
            </div>
          </form>
        </div>
      </div>

      <!-- Footer -->
      <footer class="auth-footer">
        <div class="footer-content">
          <p>&copy; Copyright 2025 Bert Solution All rights reserved.</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import BertButton from '@/components/ui/Button.vue';
import BertLoading from '@/components/ui/Loading.vue'

export default {
  name: "NewUserLogin",
  components: {
    BertButton,
    BertLoading
  },
  data() {
    return {
      isLoading: false,
      errors: [],
      forms: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push("/");
    },
    submitData() {
      if (this.forms.username.trim() && this.forms.password.trim()) {
        let formData = new FormData();
        formData.append("username", this.forms.username.trim());
        formData.append("password", this.forms.password);

        const baseURI = this.$settings.endPoint + "auth/login";
        this.isLoading = true;

        this.$http
          .post(baseURI, formData)
          .then(response => {
            this.isLoading = false;
            if (response.data.status === 200) {
              // Use the global auth functions
              this.$setAuthToken(response.data.datas.access_token);
              
              var userInfo = this.$getUserInfo();
              localStorage.setItem("userModels", JSON.stringify(userInfo));
              
              this.success("Login berhasil! Selamat datang.");
              setTimeout(() => {
                this.$router.push("/dashboard");
              }, 1500);
            } else {
              this.errors = response.data.errors;
              this.resultError(response.data.errors);
            }
          })
          .catch(error => {
            this.isLoading = false;
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 401) {
                this.error("Email atau kata sandi salah");
              } else if (error.response.status === 500) {
                this.$router.push("/server-error");
              } else {
                this.$router.push("/page-not-found");
              }
            }
          });
      } else {
        this.error("Email dan kata sandi wajib diisi");
      }
    },

    resetForm() {
      this.forms = {
        username: "",
        password: ""
      };
    },

    togglePassword(fieldId) {
      const field = document.getElementById(fieldId);
      const icon = field.nextElementSibling;
      
      if (field.type === "password") {
        field.type = "text";
        icon.classList.remove("mdi-eye");
        icon.classList.add("mdi-eye-off");
      } else {
        field.type = "password";
        icon.classList.remove("mdi-eye-off");
        icon.classList.add("mdi-eye");
      }
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: toast => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: message
      });
    },

    error(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: toast => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "error",
        title: message
      });
    }
  }
};
</script>

<style scoped>
/* Global Styles */
.new-login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  font-family: 'Roboto', sans-serif;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.login-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Desktop Layout */
.desktop-layout {
  display: flex;
  min-height: calc(100vh - 60px);
  flex: 1;
}

.banner-section {
  flex: 0.7;
  background: url('~@/assets/banner-auth.svg') ;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2rem;
}

.banner-content {
  text-align: center;
  position: relative;
}

.banner-image {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.banner-content {
  text-align: center;
  position: relative;
}

.banner-image {
  max-width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

.member-badge {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
}

.member-image {
  max-width: 280px;
  height: auto;
}

.form-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: white;
}

.form-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  padding: 3rem 2.5rem;
  width: 100%;
  max-width: 450px;
  border: 1px solid #f0f0f0;
}

.form-container {
  width: 100%;
}

.logo-container {
  text-align: start;
  margin-bottom: 2rem;
}

.logo {
  height: 60px;
  width: auto;
}

.form-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 2rem;
}

.login-form {
  width: 100%;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: #6c757d;
  font-size: 1.1rem;
  z-index: 2;
}

.input-wrapper input {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.input-wrapper input:focus {
  outline: none;
  border-color: #ffc107;
  background: white;
  box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.1);
}

.password-toggle {
  position: absolute;
  right: 12px;
  color: #6c757d;
  cursor: pointer;
  font-size: 1.1rem;
}

.password-toggle:hover {
  color: #495057;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  margin-bottom: 1.5rem;
}

.forgot-password,
.register-link {
  text-align: center;
  margin: 1rem 0;
  color: #6c757d;
}

.forgot-password,
.register-link {
  text-align: center;
  margin: 1rem 0;
  color: #6c757d;
}

.link-primary {
  color: #ffc107;
  text-decoration: none;
  font-weight: 600;
}

.link-primary:hover {
  color: #e0a800;
  text-decoration: underline;
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 3rem;
}

/* Mobile Layout */
.mobile-layout {
  display: none;
  padding: 1rem;
}

.mobile-container {
  margin: 2rem 0;
}

.mobile-logo {
  text-align: start;
  margin-bottom: 1.5rem;
}

.mobile-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  text-align: start;
  margin-bottom: 1.5rem;
}

.mobile-form-group {
  margin-bottom: 1.5rem;
}

.mobile-form-group label {
  display: block;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.mobile-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.mobile-input-wrapper input {
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.mobile-input-wrapper input:focus {
  outline: none;
  border-color: #ffc107;
  background: white;
  box-shadow: 0 0 0 3px rgba(255, 193, 7, 0.1);
}

.mobile-forgot-password,
.mobile-register-link {
  text-align: center;
  margin: 1rem 0;
  color: #6c757d;
}

.mobile-form-actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
}

/* Footer */
.auth-footer {
  background: #2c3e50;
  color: white;
  padding: 1rem 0;
  text-align: center;
  margin-top: auto;
}

.footer-content p {
  margin: 0;
  font-size: 0.9rem;
}


/* Fixed Back Button */
.back-button-fixed {
  position: fixed;
  top: 2rem;
  left: 2rem;
  z-index: 1000;
}

.back-button-circle {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: white;
  border: 2px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.back-button-circle:hover {
  background: #ffc107;
  border-color: #ffc107;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 193, 7, 0.3);
}

.back-button-circle i {
  font-size: 1.2rem;
  color: #6c757d;
  transition: color 0.3s ease;
}

.back-button-circle:hover i {
  color: white;
}

/* Responsive Design */
@media (max-width: 768px) {
  .desktop-layout {
    display: none;
  }
  
  .mobile-layout {
    display: block;
  }
  
  .new-login-container {
    padding: 0;
  }
}

@media (max-width: 1024px) {
  .banner-section {
    flex: 0.8;
  }
  
  .form-section {
    flex: 1.2;
  }
}

/* Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-container,
.mobile-container {
  animation: fadeIn 0.6s ease-out;
}

/* Focus states for accessibility */
.input-wrapper input:focus,
.mobile-input-wrapper input:focus {
  outline: 2px solid #ffc107;
  outline-offset: 2px;
}

.btn-login:focus,
.btn-cancel:focus,
.mobile-btn-login:focus,
.mobile-btn-cancel:focus {
  outline: 2px solid #ffc107;
  outline-offset: 2px;
}
</style>